/** D-142 on every exam's home: what is free (no card), the mock oral with a trainer (price from
 * the catalogue) and the review the learner may leave after a mock, a session or a result. */

import { useAcademyOralOfferRetrieve } from "@agencyos/api-client";
import { formatXaf } from "@agencyos/core";
import { buttonClass } from "@agencyos/ui-web";
import { Mic } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { FreeMockCard } from "../sales/FreeMockCard";
import { FreeStart } from "../sales/FreeStart";
import { ReviewPrompt } from "./ReviewPrompt";
import "./coaching.css";

function OralHomeCard() {
  const { t } = useTranslation();
  const offer = useAcademyOralOfferRetrieve({ query: { retry: false, staleTime: 300_000 } });
  const data = offer.data?.status === 200 ? offer.data.data : undefined;
  if (!data?.available || !data.exams.length) return null;
  return (
    <section className="ac-surface ac-card co-book" aria-labelledby="co-home-title">
      <h2 id="co-home-title" className="ac-title-3">
        <Mic aria-hidden size={16} /> {t("coaching.home.title")}
      </h2>
      <p className="ac-secondary">{t("coaching.home.text", { price: formatXaf(data.price_xaf) })}</p>
      <Link className={buttonClass("secondary")} to="/academy/oral">
        {t("coaching.home.cta")}
      </Link>
    </section>
  );
}

export function HomeExtras() {
  return (
    <>
      <FreeMockCard />
      <FreeStart />
      <OralHomeCard />
      <ReviewPrompt />
    </>
  );
}
